import { render, staticRenderFns } from "./EditFeedback.vue?vue&type=template&id=73f946e8&"
import script from "./EditFeedback.vue?vue&type=script&lang=js&"
export * from "./EditFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports